import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import Moment from 'react-moment'
import moment from 'moment'
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import agent from '../agent'
import Aux from './AuxContainer'
import BasicInfo from '../components/BasicInfo'
import DashboardAvatar from '../components/DashboardAvatar'
import Back from '../components/Back'
import AMLogo from '../assets/images/audition-magic-favicon.png'
import { Field, reduxForm } from 'redux-form'
import { store, history } from '../store/configureStore'
import filter from 'lodash/filter'
import concat from 'lodash/concat'
import artistType from '../data/artist-type';

import ProfileForm from '../components/profile/ProfileForm'
import Statistics from '../components/profile/Statistics'
import UploadImageForm from '../components/profile/UploadImageForm'
import ResumeForm from '../components/profile/ResumeForm'
import SkillForm from '../components/profile/SkillForm'
import RepresentationForm from '../components/profile/RepresentationForm'

import TestForm from '../components/profile/TestForm'

const ComingSoon = () => {
	const itemStyle = {
		textAlign: 'center',
		fontSize: '-webkit-xxx-large',
		color: '#fff'
	}
	const rowStyle = {
		backgroundColor: '#2C2D2D',
		maxWidth: 'none'
	}
	return (
		<div className="row large-12" style={rowStyle}>
		<div className="column large-12"><p style={itemStyle}>Coming Soon</p></div></div>
		)
}

class UpdateProfileAgency extends Component {
	state = {
		general: 'general-selected',
		representation: 'representation',
		statistics: 'statistics',
		image: 'image',
		skills: 'skills',
		resume: 'resume',
		media: 'media',
		generalCl: 'tabs-panel tab-panel-fix is-active',
		representationCl: 'tabs-panel tab-panel-fix',
		statisticsCl: 'tabs-panel tab-panel-fix',
		imageCl: 'tabs-panel tab-panel-fix',
		skillsCl: 'tabs-panel tab-panel-fix',
		resumeCl: 'tabs-panel tab-panel-fix',
		mediaCl: 'tabs-panel tab-panel-fix',
		showModal_info: false,
		disableButton: false,
		resumeInfo: this.props.artistInfo.resume,
		skillsInfo: this.props.artistInfo.skills,
		artist: {}
	}

	componentWillMount() {
		this.setState({
			artist: { 
				artist : { 
					first_name: this.props.artistInfo.first_name,
				      last_name: this.props.artistInfo.last_name,
				      mobile_number: this.props.artistInfo.mobile_number,
				      artist_type: this.props.artistInfo.artist_type,
				      email: this.props.artistInfo.email,
				      id: this.props.artistInfo.id,
				      gender: this.props.artistInfo.gender,
				      category: this.props.artistInfo.category,
				      age_from: this.props.artistInfo.age_from,
				      age_to: this.props.artistInfo.age_to,
				      birth_date: this.props.artistInfo.birth_date,
				      country: this.props.artistInfo.country,
				      state: this.props.artistInfo.state,
				      ageCategory: 'adult'
				}
			}
		})
	}

	changePage = (value) => {
		this.setState({
		   	general: value === 'general' ? 'general-selected' : 'general',
		   	representation: value === 'representation' ? 'representation-selected' : 'representation',
		   	statistics: value === 'statistics' ? 'statistics-selected' : 'statistics',
		   	image: value === 'image' ? 'image-selected' : 'image',
		   	skills: value === 'skills' ? 'skills-selected' : 'skills',
		   	resume: value === 'resume' ? 'resume-selected' : 'resume',
		   	media: value === 'media' ? 'media-selected' : 'media',
		   	generalCl: value === 'general' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	representationCl: value === 'representation' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	statisticsCl: value === 'statistics' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	imageCl: value === 'image' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	skillsCl: value === 'skills' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	resumeCl: value === 'resume' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
		   	mediaCl: value === 'media' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix'
		   })
	}

	submit = (values, dispatch, props) => {
		const { artistInfo } = this.props
		this.setState({ disableButton: true })
		let params = {}

		const getFormData = (object, namespace) => Object.keys(object).reduce((formData, key) => {	
			let formKey = namespace ? `${namespace}[${key}]` : key
			if (key == 'statistics') {
				let val = Object.keys(object[key]).reduce((innerFormData, key2) => {
						let formKey2 = `${namespace}[${key}][${key2}]`
						formData.append(formKey2, object[key][key2])
						console.log('inner-pa-po', formKey2, object[key][key2])
						return innerFormData
					}, new FormData());
			} else {
				formData.append(formKey, object[key])
			}
			return formData
		}, new FormData());

		if (this.state.general == 'general-selected') {
			params = {
				artist: {
					gender: values.artist.gender,
					category: values.artist.category,
					state: values.artist.state,
					country: values.artist.country,
					union: values.artist.hasUnion,
					union_id: values.artist.union_id
				}
			}
			if (values.artist.ageCategory === 'adult') {
				params.artist.age_from = values.artist.age_from
				params.artist.age_to = values.artist.age_to
			} else {
				params.artist.birth_date = values.artist.birth_date
			}
		} else if (this.state.statistics == 'statistics-selected') {
			// let arrStat = []
			// for(var key in values.artist.statistics) {
			// 	let json = { label: key, value: values.artist.statistics[key] }
			// 	arrStat.push(json)
			// }
			// console.log('before-stat', arrStat)
			params = {
				artist: {
					statistics: values.artist.statistics,
					statistics_region: values.artist.statistics_region,
					statistics_unit: values.artist.statistics_unit,
					measurement_sizing: values.artist.measurement_sizing
				}
			}
		} else if (this.state.image == 'image-selected') {
			params = {
				artist: {
					avatar: values.photo,
					active_avatar: "",
				}
			}
		} else if (this.state.representation == 'representation-selected') {
			//freelance
			if (values.representation === 'freelance') {
				params = {
					artist: {
						company_id: null,
						artist_type: 'freelance'
					}
				}
			}
			//represented
			if (values.representation === 'represented' && values.artist) {
				params = {
					artist: {
						company_id: values.artist.company_id,
						artist_type: 'represented'
					}
				}
			}
			//represented (new agency)
			if (values.representation === 'represented' && values.agency) {
				params = {
					artist: {
						agency: values.artist.agency,
						artist_type: 'represented',
						searchAgency: values.artist.searchAgency
					}
				}
			}
			console.log('representation-me', values, params)
		} else if (this.state.resume == 'resume-selected') {
			//code here
			const val = JSON.parse(window.localStorage.getItem('global_artist'));
			console.log('resume', val)
			var arrMatrix = []
			val.map((k, i) => {
				//let temp = getFormData(k, 'artist')
				var arrSection = []
				if (k.type === 'text') {
					arrSection.push(k.title)
					arrSection.push(k.content)
					arrMatrix.push(arrSection)
				}
				if (k.type === 'table') {
					arrSection.push(k.title)
					k.rowCredits.map((j, g) => {
						var innerArr = []
						let flag = false
						if (j.col1 !== "" && j.col1 != null && j.col1 != 'undefined') {
							innerArr.push(j.col1)
							flag = true
						}
						if (j.col2 !== "" && j.col2 != null && j.col2 != 'undefined') {
							innerArr.push(j.col2)
							flag = true
						}
						if (j.col3 !== "" && j.col3 != null && j.col3 != 'undefined') {
							innerArr.push(j.col3)
							flag = true
						}
						if (j.col4 !== "" && j.col4 != null && j.col4 != 'undefined') {
							innerArr.push(j.col4)
							flag = true
						}
						if (j.col5 !== "" && j.col5 != null && j.col5 != 'undefined') {
							innerArr.push(j.col5)
							flag = true
						}
						if (flag)
							arrSection.push(innerArr)
					})
					//arrSection.push(k.rowCredits)
					arrMatrix.push(arrSection)
				}
			})
			params = {
				artist: {
					...values.artist,
					resume: JSON.stringify(arrMatrix)
				}
			}
		} else if (this.state.skills == 'skills-selected') {
			//code here
			const val = JSON.parse(window.localStorage.getItem('global_artist_skills'));
			var arrMatrix = []
			Object.keys(val).map((key, index) => {
				let arrSkill = []
				if (val[key].length >= 1) {
					val[key].map((k, i) => {
						let arrTemp = []
						arrTemp.push(key, k.name, k.level, k.media)
						arrSkill.push(arrTemp)
					})
					arrMatrix.push(arrSkill)
				}
			})
			params = {
				artist: {
					...values.artist,
					skills: JSON.stringify(arrMatrix)
				}
			}
		}
		console.log('submit-me', params, artistInfo)
		if (Object.keys(params).length !== 0) {
			agent.Artist.updateProfile(artistInfo.id, getFormData(params.artist, 'artist')).then((k) => {
			  console.log('updateProfile', k)
		      this.setState({ showModal_info: true, disableButton: false, resumeInfo: k.artist.resume, skillsInfo: k.artist.skills })
		      window.localStorage.removeItem('global_artist')
		    });
	    } else {
	    	console.log('submit-me-last', Object.keys(params).length)
	    }
	}

	sample = (values, dispatch, props) => {
		const val = JSON.parse(window.localStorage.getItem('global_artist'));
		
		const params = val.map((k, i) => {
			var arrSection = []
			var arrMatrix = []
			const key = 'artist[resume]'
			let formData = new FormData()
			if (k.type === 'text') {
				arrSection.push(k.title)
				arrSection.push(k.content)
				arrMatrix.push(arrSection)
				arrSection = []
			}
			if (k.type === 'table') {
				arrSection.push(k.title)
				arrSection.push(k.rowCredits)
				arrMatrix.push(arrSection)
				arrSection = []
			}
			formData.append(key, arrMatrix)
			return formData
		})
		agent.Artist.updateProfile(values.artist.id, params).then((k) => {
	      console.log('sample', params, val, values)
	    });
	}

	onCloseModal = () => {
	    this.setState({ showModal_info: false });
	 }

	render() {
		const { location, artistInfo } = this.props
		const liCl = window.innerWidth < 400 ? 'column small-12 medium-3 tabs-title item-content' : 'tabs-title item-content'
		const labels = {
			label: 'Talent is'
		}

		return (
			<div>
				<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal_info} onClose={this.onCloseModal} little>
	              <h2 className="reveal-title">SUCCESS</h2> 
	              
	              <div className="margin-bottom-here">You have successfully saved your information!</div>
	              
	              <div className="clearfix"></div>
	              <button className="button float-left" onClick={this.onCloseModal}>Close</button>
	          	</Modal>
				<nav className="action-nav">
					<ul className="filters tabs" data-tabs id="profile-selection-tabs">
						<li className="tabs-title tabs-title-fix">
							<div className="row">
								<div className="column artist-card">
									<div className="column medium-3 artist-photo">
										<img src={artistInfo.photo || artistInfo.photo_thumb} />
									</div>
									<div className="column medium-9 artist-details">
										<p>{artistInfo.first_name} {artistInfo.last_name} | {artistInfo.category}</p>
										<p className="none-bold">{artistInfo.at2_agency_name}</p>
									</div>
								</div>
							</div>
						</li>
						<li className="tabs-title is-active item-content">
							<a onClick={e => this.changePage("general")} aria-selected={this.state.general == 'general-selected'}>
			              		General
			              	</a>
						</li>
						{
							/*<li className={liCl}>
								<a onClick={e => this.changePage("representation")} aria-selected={this.state.representation == 'representation-selected'}>
				              		Representation
				              	</a>
							</li>*/
						}
						<li className={liCl}>
							<a onClick={e => this.changePage("statistics")} aria-selected={this.state.statistics == 'statistics-selected'}>
				              	Statistics
				            </a>
						</li>
						<li className={liCl}>
							<a onClick={e => this.changePage("image")} aria-selected={this.state.image == 'image-selected'}>
			              		<div className={this.state.image}></div>Primary Image
			              	</a>
						</li>
						<li className={liCl}>
			              	<a onClick={e => this.changePage("skills")} aria-selected={this.state.skills == 'skills-selected'}>
			              		<div className={this.state.skills}></div>Skills
			              	</a>
			            </li>
			            <li className={liCl}>
			              	<a onClick={e => this.changePage("resume")} aria-selected={this.state.resume == 'resume-selected'}>
			              		<div className={this.state.resume}></div>Resume
			              	</a>
			            </li>
			            <li className="tabs-title item-content hide">
			              	<a onClick={e => this.changePage("media")} aria-selected={this.state.media == 'media-selected'}>
			              		<div className={this.state.media}></div>Media-Test
			              	</a>
			            </li>
					</ul>
				</nav>
				<div className="tabs-content tabs-content-fix" data-tabs-content="profile-selection-tabs">
					<div className={this.state.generalCl}>
					{ this.state.general == 'general-selected' &&
						(<ProfileForm artistType={artistType} onSubmit={this.submit} disableButton={this.state.disableButton} 
						ageCategory={artistInfo.ageCategory} artistInfo={this.state.artist} labels={labels} />) }
					</div>
					{
						/*<div className={this.state.representationCl}>
						{ this.state.representation == 'representation-selected' &&
								(<RepresentationForm
						            onSubmit={this.submit}
						            hidRepresent={false}
						            location={location}
						            representation={represent}
						          />) }
						</div>*/
					}
					<div id="stat-form-wizard" className={this.state.statisticsCl}>
					{ this.state.statistics == 'statistics-selected' &&
							(<Statistics artist={artistInfo} onSubmit={this.submit} disableButton={this.state.disableButton} />) }
					</div>
					<div className={this.state.imageCl}>
					{ this.state.image == 'image-selected' && 
						(<UploadImageForm artist={artistInfo} onSubmit={this.submit} disableButton={this.state.disableButton} />) }
					</div>
					<div className={this.state.skillsCl}>
					{ this.state.skills == 'skills-selected' &&
						(<SkillForm onSubmit={this.submit} skills={this.state.skillsInfo} artist={artistInfo} />) }
					</div>
					<div className={this.state.resumeCl}>
					{ this.state.resume == 'resume-selected' &&
						(<ResumeForm onSubmit={this.submit} resume={this.state.resumeInfo} artist={artistInfo} />) }
					</div>
					<div className={this.state.mediaCl}><TestForm onSubmit={this.sample} /></div>
				</div>
			</div>)
	}
}


// TODO
// get only the props that are needed
const mapStateToProps = state => ({
	
})
const mapDispatchToProps = (dispatch) => ({
	
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateProfileAgency)


// WEBPACK FOOTER //
// ./src/containers/UpdateProfileAgency.js